module.exports = __webpack_public_path__ + "static/headshot--casual--cropped--edited-cb89111674055246d499e5fe0499cb1e.jpeg";